import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPosts } from "@/lib/api";
import { categoryStyle } from "@/lib/constants";

/**
 * "You May Be Interested in This, Too!" — renders up to 4 thumbnails of
 * other posts in the same category. Hidden if there are zero matches.
 */
export default function RelatedPostsBlock({ category, excludeSlug }) {
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!category) return;
        let cancelled = false;
        getPosts(null, { category, excludeSlug, limit: 4 })
            .then((data) => {
                if (!cancelled) setItems((data || []).slice(0, 4));
            })
            .catch((err) => {
                console.error("RelatedPostsBlock load failed:", err);
                if (!cancelled) setItems([]);
            });
        return () => {
            cancelled = true;
        };
    }, [category, excludeSlug]);

    if (items.length === 0) return null;

    return (
        <section
            className="mt-16 pt-10 border-t border-[#1B1B1B]/10"
            data-testid="related-posts-block"
        >
            <div
                className="h-px w-10 bg-[#E63B26] mb-4"
                aria-hidden="true"
                data-testid="related-posts-accent"
            />
            <h3
                className="font-poppins font-semibold text-2xl sm:text-3xl tracking-tight"
                style={{ color: "#E63B26" }}
            >
                Because You Have Great Taste
            </h3>
            <p className="font-sofia text-sm text-[#1B1B1B]/60 mt-1">
                More from <span className="uppercase tracking-[0.18em]">{category}</span>
            </p>

            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
                {items.map((p) => (
                    <Link
                        key={p.id}
                        to={`/post/${p.slug}`}
                        className="post-card relative block overflow-hidden bg-[#1B1B1B] group"
                        data-testid={`related-post-${p.slug}`}
                    >
                        <div className="relative aspect-square overflow-hidden">
                            <img
                                src={p.image_url}
                                alt={p.title}
                                loading="lazy"
                                className="post-card-image absolute inset-0 w-full h-full object-cover"
                            />
                            <span
                                className="badge-category absolute top-2 left-2 z-10 text-[0.6rem]"
                                style={categoryStyle(p.category)}
                            >
                                {p.category}
                            </span>
                            <div className="post-card-caption">
                                {p.title.length > 56
                                    ? p.title.slice(0, 53) + "..."
                                    : p.title}
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}
